<template>
  <div>
    <div v-if="estimate">
      <div class="mb-2">
        <span v-if="subscription.status === 'order'">{{ $t('subscription') }} </span>
        <span v-else>{{ $t('edit-subscription') }} </span>

        <strong>
          <v-icon>{{ moduleConfig.display['icon'] }}</v-icon>
          {{ moduleConfig.display['name'] }} {{ $t('offer') }} {{ modulePlanConfig.label }}
        </strong>
      </div>

      <v-simple-table dense>
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-left">
              Nom
            </th>
            <th class="text-right">
              Prix HT
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, i) in estimate.items" :key="i">
            <td v-html="item.name"></td>
            <td class="text-right">
              <div>
                {{ $helpers.present.currency(item.amount / 100) }}
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="3" class="text-right pt-4">
              <div>
                <span class="total-label">Total HT :</span>
                {{ $helpers.present.currency(estimate.subtotal / 100) }}
              </div>
              <div v-if="estimate.discount">
              <span class="total-label blue--text text--darken-2">
               {{ $t('discount') }} {{ $helpers.present.currency(estimate.discount / 100 * -1) }}
              </span>
              </div>
              <div v-if="estimate.discount">
                <span class="total-label"> {{ $t('total') }} {{ $t('prices.without-taxes') }} :</span>
                {{ $helpers.present.currency((estimate.subtotal - estimate.discount) / 100) }}
              </div>
              <div v-if="estimate.tax">
                <span class="total-label">{{ $t('prices.taxes') }} :</span>
                {{ $helpers.present.currency(estimate.tax / 100) }}
              </div>
              <div v-if="estimate.tax">
                <span class="total-label">{{ $t('total') }}{{ $t('prices.with-taxes') }} :</span>
                {{ $helpers.present.currency(estimate.total / 100) }}
              </div>
              <div v-if="immediateDowngrade">
                <div>
                  <span class="total-label">{{ $t('paid') }}Déjà payé :</span>
                  {{ $helpers.present.currency(estimate.total / 100 * -1) }}
                </div>
                <div>
                  <span class="total-label">{{ $t('total') }}{{ $t('prices.with-taxes') }} :</span>
                  {{ $helpers.present.currency(0) }}
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
      <small v-if="estimate.footer">{{ estimate.footer }}</small>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubscriptionEstimate',
  props: ['subscription', 'estimate', 'immediateDowngrade'],
  computed: {
    moduleConfig () {
      return this.$module.all[this.subscription.module]
    },
    modulePlanConfig () {
      return this.$module.all[this.subscription.module].plan.list[this.subscription.plan]
    },
  }
}
</script>

<style scoped>
.total-label {
  color: rgba(0, 0, 0, 0.6);
  font-weight: 700
}

.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: #ffffff;
}
</style>

<i18n>
{
	"en": {
		"discount": "Reduction :",
		"edit-subscription": "Modification of your subscription",
		"offer": "offer",
		"paid": "Already paid :",
		"subscription": "Your subscription",
		"total": "Total"
	},
	"es": {
		"discount": "Reducción :",
		"edit-subscription": "Modificación de su suscripción",
		"offer": "oferta",
		"paid": "Ya pagado :",
		"subscription": "Su suscripción",
		"total": "Total"
	},
	"fr": {
		"discount": "Réduction : ",
		"edit-subscription": "Modification de votre souscription",
		"offer": "offre",
		"paid": "Déjà payé :",
		"subscription": "Votre souscription",
		"total": "Total"
	},
	"it": {
		"discount": "Riduzione :",
		"edit-subscription": "Modifica del tuo abbonamento",
		"offer": "offerta",
		"paid": "Già pagato :",
		"subscription": "Il tuo abbonamento",
		"total": "Totale"
	},
	"pt": {
		"discount": "Redução :",
		"edit-subscription": "Modificação da sua subscrição",
		"offer": "oferta",
		"paid": "Já pago :",
		"subscription": "A sua subscrição",
		"total": "Total"
	},
	"pl": {
		"discount": "Obniżka :",
		"edit-subscription": "Modyfikacja Twojej subskrypcji",
		"offer": "oferta",
		"paid": "Już zapłacone :",
		"subscription": "Twoja subskrypcja",
		"total": "Łącznie"
	}
}
</i18n>
